import React from 'react'
import { Input } from '@driftt/tide'
import cx from 'classnames'

import './style.css'

const URLInput = ({ url, value, onChange, className, errors = [] }) => (
  <div className={cx('url-input', {'is-existing-slug': errors.length > 0 })}>
    <div className="url-input__InputContainer">
      <div className={cx('url-input__URL', {
        [className]: className,
        error: errors.length > 0
      })}>{url}</div>
      <Input
        value={value}
        placeholder="article-url"
        onChange={onChange}
        className={cx('article-modal-content-url-input' , { error: errors.length > 0 })}
      />
    </div>
  </div>
)

export default URLInput